module.exports = __webpack_public_path__ + "media/images/welcome-83945835.svg";